export const BULK_MAS_PAGE = 0;
export const BASE_MAS_PAGE = 1;
export const MARK_AS_SHIPPED_BULK_TRACKING_ID = '/orders/awaiting-shipment#other-actions-bulk-mark-as-shipped';
export const MARK_AS_SHIPPED_CARRIER_ID = 'carrierId';
export const MARK_AS_SHIPPED_DEDUCT_INVENTORY = 'deductInventory';
export const MARK_AS_SHIPPED_NOTIFY_CUSTOMER = 'notifyCustomer';
export const MARK_AS_SHIPPED_NOTIFY_MARKETPLACE = 'notifyMarketplace';
export const MARK_AS_SHIPPED_SHIP_FROM_ID = 'shipFromId';
